import React from 'react';
import { ArrowLeftIcon, ChartBarIcon } from '@heroicons/react/24/outline';

interface BacktestComparisonProps {
  backtestIds: string[];
  onBack: () => void;
}

const BacktestComparison: React.FC<BacktestComparisonProps> = ({ backtestIds, onBack }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4">
            <button
              onClick={onBack}
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <ArrowLeftIcon className="h-5 w-5 mr-2" />
              Back to Backtests
            </button>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                Backtest Comparison
              </h1>
              <p className="mt-2 text-gray-600">
                Comparing {backtestIds.length} backtests
              </p>
            </div>
          </div>
        </div>

        {/* Coming Soon Notice */}
        <div className="bg-white rounded-lg p-12 shadow-sm text-center">
          <ChartBarIcon className="mx-auto h-16 w-16 text-gray-400 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Backtest Comparison Coming Soon
          </h3>
          <p className="text-gray-600 mb-6">
            The backtest comparison feature with side-by-side performance metrics,
            equity curve overlays, and statistical analysis will be implemented
            in the next development phase.
          </p>
          <div className="text-sm text-gray-500">
            <p><strong>Selected Backtests:</strong> {backtestIds.length}</p>
            <ul className="mt-2">
              {backtestIds.map((id, index) => (
                <li key={id}>Backtest {index + 1}: {id}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BacktestComparison; 